import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { Col, VertButton, VertTypography } from '@vertem-core/vertice-ds';
import {
  convertBalance,
  convertNumberToStringCurrency,
} from 'Utils/convertPoints';
import { pointsMask } from 'Utils/commons/points';
import ynToBool from 'Utils/ynToBool';
import CheckoutDifal from 'components/Checkout/CheckoutSummary/components/CheckoutDifal';

export const PaymentSummary = ({ ...props }) => {
  const {
    pointsSelected,
    methodPayment,
    cashSelected,
    disabled,
    createOrder,
    isLoading,
  } = props;

  const PaymentConfig = useSelector(({ PaymentConfig: data }) => data);
  const PaymentInstallments = useSelector(
    ({ PaymentInstallments: data }) => data
  );
  const { paymentConfig: PointsAndCashConfig } = PaymentConfig;
  const { totalOrder } = PointsAndCashConfig;
  const Catalog = useSelector(({ Catalog: data }) => data);
  const {
    currencyConfiguration: { decimalPlaces, pointsName },
  } = Catalog;
  const { isValidCheckout } = useSelector((state) => state.DifalSlice);
  const ShippingCart = useSelector(({ Shipping: data }) => data);
  const { errorAddressCheckout, errorPhoneNumber } = useSelector(
    (state) => state.ShippingSlice
  );
  const itemsCartReducer = useSelector(({ Cart: data }) => data);
  const { coupon } = itemsCartReducer;

  const totalDiscount = coupon?.discountValue || 0;

  const isErrorShipping = ShippingCart?.hasError;

  const balanceLabel = convertBalance(totalOrder, decimalPlaces, pointsName);
  const pointsSelectedLabel = convertBalance(
    pointsSelected,
    decimalPlaces,
    pointsName
  );
  const showLabelSelected = (valueSelected, pointsName) => {
    if (valueSelected || valueSelected === 0) {
      let value = valueSelected;
      if (
        PaymentInstallments &&
        PaymentInstallments.paymentInstallments.length &&
        valueSelected === 0 &&
        pointsName === 'dinheiro'
      ) {
        value = PaymentInstallments.paymentInstallments[0]?.parcelValue || 0;
      }
      const formattedTotal = pointsMask(value, decimalPlaces, pointsName);

      return `${pointsName === 'dinheiro'
        ? convertNumberToStringCurrency(value)
        : formattedTotal.value
        } ${pointsName || ''}`;
    }
    return '-';
  };
  let disabledButton = true;

  if (ynToBool(process.env.REACT_APP_HAS_DIFAL_VALIDATION)) {
    disabledButton =
      isValidCheckout ||
      isErrorShipping ||
      errorAddressCheckout ||
      errorPhoneNumber;
  } else {
    disabledButton =
      disabled ||
      isLoading ||
      isErrorShipping ||
      errorAddressCheckout ||
      errorPhoneNumber;
  }

  return (
    <>
      <VertTypography.Title>Valor total do resgate</VertTypography.Title>
      <VertTypography.Paragraph>
        {cashSelected !== null || methodPayment === 'dinheiro'
          ? 'Pontos utilizados'
          : 'Total do resgate'}
        : {showLabelSelected(pointsSelectedLabel?.points, pointsName)}
      </VertTypography.Paragraph>
      {(() => {
        if (cashSelected !== null || methodPayment === 'dinheiro') {
          return (
            <VertTypography.Paragraph>
              Pagamento: {showLabelSelected(parseFloat(cashSelected) || 0, 'dinheiro')}
            </VertTypography.Paragraph>
          );
        }
        return '';
      })()}

      {totalDiscount > 0 && ynToBool(process.env.REACT_APP_HAS_COUPON) && (
        <VertTypography.Paragraph>
          Desconto: <b> {showLabelSelected(totalDiscount, pointsName)} </b>
        </VertTypography.Paragraph>
      )}
      <VertTypography.Paragraph>
        Total:{' '}
        <b>
          {balanceLabel.points == 0 ? (
            <span className="cart-summary-total-free">Grátis</span>
          ) : (
            <>{showLabelSelected(balanceLabel?.points, pointsName)} </>
          )}
        </b>
      </VertTypography.Paragraph>
      {ynToBool(process.env.REACT_APP_HAS_DIFAL_VALIDATION) && (
        <CheckoutDifal disabledDifal={disabled} />
      )}
      <Col className="col-12">
        <VertButton
          className="payment-summary-button"
          type="highlight"
          onClick={() => {
            createOrder();
            window.scroll(0, 0);
          }}
          size="default"
          spacing="regular"
          disabled={disabledButton}
          loading={isLoading}
        >
          Finalizar resgate
        </VertButton>
      </Col>
    </>
  );
};

PaymentSummary.propTypes = {
  pointsSelected: PropTypes.number,
  cashSelected: PropTypes.string,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  createOrder: PropTypes.func,
  methodPayment: PropTypes.string,
};
